import { ListingSection } from 'listing-details/types';
import { BaseTaxonomy } from 'shared/tracking/contracts';

const getDetailsTrackingPageFromSection = (
    section: ListingSection
): BaseTaxonomy['page'] => {
    return `/${section}/details` as BaseTaxonomy['page'];
};

export default getDetailsTrackingPageFromSection;
